
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as grddw_OQQMCu59v3D2skJ_45PESQSaS_8Jhtq_45qhSvvEMcMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index8H4gP4DxnlDqc43uPgks74UxGWjGoMWGam28pF5_U5AMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchj1SP45nRUVh3sU3JIQv0kzs7zYBM1p2IKXElqyw_pYEMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexze4ykduhomrfW_4592_45VWsY4ZZ2RH5PGlyBSawplPdR4cMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93nKSPTfyo9rlvJ2_454LcnNLXvVAfopL63bYYrvz37o22AMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexO3efjZm0ySO9gTWbb4KpRahuMYm4S4gg5HWjHt5v3HAMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93rAAi6bYIkLT3RLJ_45_8uHOVTtq612fa4RVJIBK0MmxhkMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexKyhhK3UEOODvsKlOmzI84hSViKd3z2FM5TKo8f7Zsy8Meta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93H4prxqan8aVmKdOzIgepoRdUsmNeY_fV1CuIiexQwHsMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexLJrjIEHJwEtipeDURl3VYtLexI3ThDHRHO0kXioJ2cQMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexaFAz_F0oRBwN2f0oCG871uFRDENqZFlPEDfIX5n9nygMeta } from "/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexO3efjZm0ySO9gTWbb4KpRahuMYm4S4gg5HWjHt5v3HAMeta || {},
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexKyhhK3UEOODvsKlOmzI84hSViKd3z2FM5TKo8f7Zsy8Meta || {},
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexLJrjIEHJwEtipeDURl3VYtLexI3ThDHRHO0kXioJ2cQMeta || {},
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexaFAz_F0oRBwN2f0oCG871uFRDENqZFlPEDfIX5n9nygMeta || {},
    component: () => import("/codebuild/output/src3560104325/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]